import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './signin-module.component.scss';
var SigninModule = /** @class */ (function (_super) {
    tslib_1.__extends(SigninModule, _super);
    function SigninModule(element) {
        return _super.call(this, element) || this;
    }
    SigninModule.prototype.init = function () { };
    SigninModule.prototype.bindEvents = function () { };
    return SigninModule;
}(Base));
export { SigninModule };



//////////////////
// WEBPACK FOOTER
// ./components/signin-module/signin-module.component.ts
// module id = 508
// module chunks = 0